import { urlSearch } from 'core/search';

export default ({ props }) => {
  const urlParams = urlSearch.getParams(props.location.search);

  const result = {
    page: 1,
    per_page: '',
  };

  urlParams.forEach((value, key) => {
    result[key] = value;
  });

  return result;
};
